<template>
  <div>
    <input type="radio" v-model="value" :label="label1" :value="true">
    <input type="radio" v-model="value" :label="label2" :value="false">
  </div>
</template>

<script>
export default {
  props: ['label1', 'label2', 'defaultValue'],
  data () {
    return {
      value: false
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('update', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  div {
    display: flex;
    align-items: center;
    gap: 20px;
    &>label{
      font-weight: 500;
      font-size: 18px;
      color: var(--color-base0);
      letter-spacing: .1em;
    }
  }
  input[type=radio] {
    width: 110px;
    height: 47px;
    border-radius: 5px;
    appearance: none;
    background-color: #B9B9B9;
    align-items: center;
    justify-content: center;
    display: flex;
    &::before {
      color: #FFFFFF;
      content: attr(label);
      display: inline-block;
      font-weight: 700;
      font-size: 18px;
      letter-spacing: 0.1em;
    }
    &:nth-child(1):checked {
      background-color: #85B8B9;
    }
    &:nth-child(2):checked {
      background-color: #FF6B6B;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (orientation: portrait) {}
</style>
